<template>
<div class="chapter">
<div class="inner_page">
<p class="space"> </p>
<p class="copyright3"><a id="page_4"></a><a id="Copyright">Published by<br/>
Grub Street<br/>
4 Rainham Close<br/>
London SW11 6SS</a></p><a id="Copyright">
<p class="copyright3">Copyright © Grub Street 2012<br/>
Copyright text © Christopher Shores, Giovanni Massimello,<br/>
Russell Guest, Frank Olynyk and Winfried Bock 2012</p>
<p class="copyright3"><b>British Library Cataloguing in Publication Data</b><br/>
A CIP record for this title is available from the British Library</p>
<p class="copyright3"><b>ISBN-13: 9781909166127<br/>
EPUB ISBN: 9781910690970<br/>
PRC ISBN: 9781910690970</b></p>
<p class="copyright3">All rights reserved. No part of this publication my be reproduced, stored in a retrieval system, or transmitted in any form or by any means electronic, mechanical, photocopying, recording or otherwise, without prior permission of the copyright owner.</p>
</a><p class="copyright3"><a id="Copyright">Cover design by Sarah Driver<br/>
Design by Roy Platten, Eclipse, Hemel Hempstead<br/>
</a><a href="http://roy.eclipse@btopenworld.com" target="_blank">roy.eclipse@btopenworld.com</a></p>
<p class="copyright3">Printed and bound by Berforts Group, UK</p>
<p class="copyright3">Grub Street Publishing only uses FSC<br/>
(Forest Stewardship Council) paper for its books.</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 03_Copyright.vue?4f056d40